export default "<p>helper-functions works!</p>\r\n"